import { Helmet } from "react-helmet";


function SEOManager({ metaTitle, metaDescription, canonical }) {
   const baseUrl = window.location.origin;
    const canonicalUrl =
    canonical && canonical.startsWith("http")
      ? canonical
      : canonical
      ? `${baseUrl}/${canonical.replace(/^\/+/, "")}`
      : window.location.href;

  return (
    <Helmet>     
       <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
    </Helmet>
  );
}

export default SEOManager;
